import React from 'react';
import Icon from '../../../components/AppIcon';

const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      icon: 'FileText',
      title: 'Récupérez votre référence',
      description: 'Sur votre bon de commande ou dans votre email de confirmation (format ADT-YYYY-XXXX)'
    },
    {
      number: '2',
      icon: 'Search',
      title: 'Entrez-la ci-dessus',
      description: 'Collez votre référence dans la barre de recherche'
    },
    {
      number: '3',
      icon: 'Clock',
      title: 'Suivez en temps réel',
      description: 'Visualisez chaque étape de votre envoi de Paris à Abidjan'
    }
  ];

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 sm:p-10">
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold text-gray-900 mb-3">
          Comment suivre votre envoi ?
        </h2>
        <p className="text-gray-600">
          3 étapes simples pour suivre votre colis
        </p>
      </div>
      
      <div className="relative">
        {/* Connecting Line */}
        <div className="hidden md:block absolute top-12 left-0 right-0 h-0.5 border-t-2 border-dashed border-green-300" style={{ marginLeft: '16.66%', marginRight: '16.66%' }} />
        
        <div className="grid md:grid-cols-3 gap-8 relative">
          {steps?.map((step, index) => (
            <div key={index} className="flex flex-col items-center text-center relative">
              <div className="relative mb-4 z-10">
                <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center">
                  <Icon name={step?.icon} size={32} className="text-green-700" />
                </div>
                <div className="absolute -top-2 -right-2 w-10 h-10 bg-green-700 rounded-full flex items-center justify-center text-white text-lg font-bold shadow-lg">
                  {step?.number}
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {step?.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {step?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;